<template>
  <div class="container">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-chip label color="transparent" text-color="black">
              <h3>Búsqueda de {{ textoTopePrecio }}s Configurados</h3>
            </v-chip>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3" sm="4">
            <v-checkbox
              v-if="!esPrecio"
              v-model="soloVigentes"
              label="Buscar solo topes vigentes"
              color="primary"
              dense
              @change="buscarTopes(0)"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" sm="6">
            <v-select
              :items="profsBuscar"
              item-text="nombreProfesional"
              item-value="idProfesional"
              menu-props="auto"
              label="Profesional *"
              hide-details
              prepend-icon="mdi-account"
              v-model="prof"
              dense
              no-data-text="No hay Profesionales configurados"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <v-select
              :items="osBuscar"
              item-text="nombre"
              item-value="idObraSocial"
              menu-props="auto"
              :label="`${resolveLabel} *`"
              hide-details
              prepend-icon="mdi-account"
              v-model="os"
              dense
              :no-data-text="resolveNoData"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-form>
    <v-card-actions class="mt-0 pt-0">
      <v-spacer></v-spacer>
      <v-btn :disabled="!valid" color="primary" @click.stop="buscarTopes(1)">
        Buscar
        <v-icon dark right>mdi-magnify</v-icon>
      </v-btn>
    </v-card-actions>

    <v-data-table
      v-if="listaTopes.length"
      :headers="
        $store.state.usuario.institucion.esEmpresa ? headersEmpresa : headers
      "
      :items="this.listaTopes"
      class="elevation-1"
      locale="es-ar"
      item-key="idCMT"
      :items-per-page="10"
      ref="myTable"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageText: 'Filas por página',
      }"
    >
      <template v-if="esPrecio" v-slot:item.esSena="{ item }">
        <v-simple-checkbox v-model="item.esSena" disabled></v-simple-checkbox>
      </template>
      <template v-if="esPrecio" v-slot:item.muestraEnWeb="{ item }">
        <v-simple-checkbox
          v-model="item.muestraEnWeb"
          disabled
        ></v-simple-checkbox>
      </template>
      <template v-if="esPrecio" v-slot:item.obligaPago="{ item }">
        <v-simple-checkbox
          v-model="item.obligaPago"
          disabled
        ></v-simple-checkbox>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              medium
              color="purple"
              class="mr-3"
              v-on="on"
              v-bind="attrs"
              @click.stop="editarTope(item)"
              >mdi-pencil</v-icon
            >
          </template>
          <span>Editar {{ textoTopePrecio }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              medium
              v-on="on"
              color="red"
              v-bind="attrs"
              @click="borrarTope(item)"
              >mdi-delete</v-icon
            >
          </template>
          <span>Eliminar {{ textoTopePrecio }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-alert class="mt-4" color="purple" dark outlined v-else>
      No hay {{ !esPrecio ? "Topes" : "Precios de Consulta" }} configurados que
      coincidan con los filtros de búsqueda.
    </v-alert>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click.stop="nuevoTope"
        >Nuevo {{ textoTopePrecio }}</v-btn
      >
      <v-btn
        v-if="esPrecio"
        color="primary"
        :disabled="listaTopes.length < 1"
        @click.stop="showModalActualizarMasivo = true"
        >Actualizar Precio Masivo</v-btn
      >
      <v-btn
        color="warning"
        :disabled="listaTopes.length < 1"
        @click.stop="imprimir"
        >Imprimir</v-btn
      >
    </v-card-actions>
    <NuevoTope
      :visible="showNuevoTope"
      :esPrecio="esPrecio"
      @close="cierraNuevoTope()"
      @topeRegistrado="topeRegistrado()"
    ></NuevoTope>
    <EditarTope
      :visible="showEditarTope"
      :idCMT="editedItem.idCMT"
      :idPrecioConsulta="editedItem.idPrecioConsulta"
      :esPrecio="esPrecio"
      @close="cierraEditarTope()"
      @topeModificado="topeModificado()"
    ></EditarTope>
    <v-dialog v-model="showModalActualizarMasivo" max-width="450" persistent>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="showModalActualizarMasivo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Actualizar Precio Masivo</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pt-4">
          <v-alert type="info" outlined dense>
            Se actualizará el precio de consulta de todos los registros que coinciden con los filtros actuales.
          </v-alert>
          <v-text-field
            v-model="nuevoPrecioMasivo"
            prepend-icon="mdi-currency-usd"
            label="Nuevo Precio Consulta *"
            :rules="[(v) => v !== '' && v !== null || 'Dato obligatorio', (v) => v >= 0 || 'Debe ser mayor o igual a 0']"
            @keypress="onlyNumberAndDot"
            maxlength="10"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            :disabled="nuevoPrecioMasivo === null || nuevoPrecioMasivo === '' || Number(nuevoPrecioMasivo) < 0"
            :loading="actualizandoMasivo"
            @click="actualizarPrecioMasivo"
          >Actualizar</v-btn>
          <v-btn color="error" @click="showModalActualizarMasivo = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>
<script>
import axios from "../../../axios-auth.js";
import jsPDF from "jspdf";
import NuevoTope from "../Configuraciones/NuevoTope.vue";
import EditarTope from "../Configuraciones/EditarTope.vue";

export default {
  props: {
    esPrecio: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: (vm) => ({
    valid: false,
    lazy: false,
    soloVigentes: true,
    prof: "",
    profsBuscar: [],
    os: "",
    osBuscar: [],
    listaTopes: [],
    headersEmpresa: [
      { text: "Profesional", value: "nombreProfesional" },
      { text: "Sede", value: "nombre" },
      { text: "Tope Diario", value: "cantMax" },
      { text: "Vig. Desde", value: "fechaDesdeString" },
      { text: "Vig. Hasta", value: "fechaHastaString" },
      { text: "Acciones", value: "actions" },
    ],
    showNuevoTope: false,
    showEditarTope: false,
    showModalActualizarMasivo: false,
    nuevoPrecioMasivo: null,
    actualizandoMasivo: false,
    editedItem: {},
    editedIndex: -1,
  }),
  computed: {
    resolveLabel() {
      return this.$store.state.usuario.institucion.esEmpresa
        ? "Sede"
        : "Obra Social";
    },
    resolveNoData() {
      return this.$store.state.usuario.institucion.esEmpresa &&
        (this.dni ||
          this.apellidos ||
          this.nombres ||
          this.prof ||
          this.profsBuscar)
        ? "No hay Sedes configuradas"
        : "No hay Obras Sociales configuradas";
    },
    textoTopePrecio() {
      return this.esPrecio ? "Precio" : "Tope";
    },
    headers() {
      return this.esPrecio
        ? [
            { text: "Profesional", value: "nombreProfesional" },
            { text: "Obra Social", value: "nombreObraSocial" },
            { text: "Tipo de Turno", value: "nombreTipoTurno" },
            { text: "Es Seña", value: "esSena" },
            { text: "Muestra precio en Web", value: "muestraEnWeb" },
            {
              text: "Requiere pago para confirmar turno",
              value: "obligaPagoString",
            },
            {
              text: "Período para confirmar turno",
              value: "cantDiasConfirmacionString",
            },
            {
              text: "Precio Consulta",
              align: "end",
              value: "precioConsultaString",
            },
            {
              text: "Precio Final",
              align: "end",
              value: "precioFinalString",
            },
            { text: "Acciones", value: "actions" },
          ]
        : [
            { text: "Profesional", value: "nombreProfesional" },
            { text: "Obra Social", value: "nombre" },
            { text: "Tope Diario", value: "cantMax" },
            { text: "Vig. Desde", value: "fechaDesdeString" },
            { text: "Vig. Hasta", value: "fechaHastaString" },
            { text: "Acciones", value: "actions" },
          ];
    },
  },
  methods: {
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 1500,
      });
    },
    borrarTope(item) {
      this.$swal({
        title: `Borrar ${this.textoTopePrecio}`,
        text: `¿Desea borrar el ${this.textoTopePrecio}?`,
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const params = this.esPrecio
            ? { idPrecioConsulta: item.idPrecioConsulta }
            : { idCMT: item.idCMT };
          const endpoint = this.esPrecio
            ? "/ObraSocial/BorrarPrecio?"
            : "/ObraSocial/BorrarTope?";
          let self = this;
          axios
            .get(endpoint, {
              params,
            })
            .then((response) => {
              self.showAlert({
                icon: "success",
                title: `${self.textoTopePrecio} borrado exitosamente`,
                vm: self,
              });
              setTimeout(self.buscarTopes(0), 1700);
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: `El ${self.textoTopePrecio} no pudo ser borrado`,
                vm: this,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    cierraNuevoTope() {
      this.showNuevoTope = false;
      //this.buscarObrasSociales();
    },
    cierraEditarTope() {
      this.showEditarTope = false;
      //this.buscarObrasSociales();
    },
    topeRegistrado() {
      this.showNuevoTope = false;
      this.buscarTopes(0);
    },
    topeModificado() {
      this.showEditarTope = false;
      this.buscarTopes(0);
    },
    nuevoTope() {
      this.showNuevoTope = true;
    },
    editarTope(item) {
      this.editedIndex = this.listaTopes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showEditarTope = true;
    },
    buscarTopes(state) {
      const params = this.esPrecio
        ? {
            idProfesional: this.prof,
            idObraSocial: this.os,
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            usuario: this.$store.state.usuario.usuario,
          }
        : {
            idProfesional: this.prof,
            idObraSocial: this.os,
            soloVigentes: this.soloVigentes,
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            usuario: this.$store.state.usuario.usuario,
          };

      let self = this;

      const endpoint = this.esPrecio
        ? "/ObraSocial/GetPreciosFiltros?"
        : "/ObraSocial/GetTopesFiltros?";
      axios
        .get(endpoint, {
          params,
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.listaTopes = response.data;
          else {
            self.listaTopes = [];
            if (state == 1) {
              self.showAlert({
                icon: "error",
                title: `No hay ${this.textoTopePrecio} que coincidan con los filtros de búsqueda ingresados.`,
                vm: self,
              });
            }
          }
        })
        .catch(function (error) {});
    },
    imprimir() {
      var source = this.$refs["myTable"];
      let rows = [];
      let columnHeader = [];

      if (this.esPrecio) {
        columnHeader = this.$store.state.usuario.institucion.esEmpresa
          ? ["Profesional", "Sede", "Tipo de Turno", "Precio Consulta"]
          : ["Profesional", "Obra Social", "Tipo de Turno", "Precio Consulta"];
      } else {
        columnHeader = this.$store.state.usuario.institucion.esEmpresa
          ? ["Profesional", "Sede", "Tope Diario", "Vig. Desde", "Vig. Hasta"]
          : [
              "Profesional",
              "Obra Social",
              "Tope Diario",
              "Vig. Desde",
              "Vig. Hasta",
            ];
      }

      if (this.esPrecio) {
        source.items.forEach((element) => {
          var temp = [
            element.nombreProfesional,
            element.nombreObraSocial,
            element.nombreTipoTurno || "TODOS",
            element.precioConsultaString,
          ];
          rows.push(temp);
        });
      } else {
        source.items.forEach((element) => {
          var temp = [
            element.nombreProfesional,
            element.nombre,
            element.cantMax,
            element.fechaDesdeString,
            element.fechaHastaString,
          ];
          rows.push(temp);
        });
      }

      var doc = new jsPDF();
      doc.setProperties({
        title: `Listado ${this.textoTopePrecio}s`,
      });

      var nombreInstitucion =
        this.$store.state.usuario.institucion.nombreInstitucion
          .toString()
          .trim();

      doc.setFontSize(12);
      doc.text(nombreInstitucion, 13, 10);
      doc.setFontSize(10);

      doc.setFontSize(16);
      doc.text(
        `Listado de ${this.textoTopePrecio}s`,
        doc.internal.pageSize.getWidth() / 2,
        33,
        {
          align: "center",
        }
      );
      doc.autoTable(columnHeader, rows, {
        startY: 39,
        didParseCell: function (table) {
          if (table.section === "head") {
            table.cell.styles.fillColor = "#c4c5c5";
          }
        },
      });

      window.open(doc.output("bloburl"), "_blank");
    },
    onlyNumberAndDot($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
        $event.preventDefault();
      }
    },
    actualizarPrecioMasivo() {
      this.$swal({
        title: "Actualizar Precio Masivo",
        text: "¿Está seguro que desea actualizar el precio de todos los registros filtrados?",
        icon: "warning",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Sí, actualizar",
        cancelButtonText: "No",
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          this.actualizandoMasivo = true;
          const datos = {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            idProfesional: this.prof || 0,
            idObraSocial: this.os || 0,
            nuevoPrecio: parseFloat(this.nuevoPrecioMasivo),
          };
          let self = this;
          axios
            .post("/ObraSocial/ActualizarPrecioMasivo", datos)
            .then((response) => {
              self.showAlert({
                icon: "success",
                title: `${response.data} precios actualizados exitosamente`,
                vm: self,
              });
              self.showModalActualizarMasivo = false;
              self.nuevoPrecioMasivo = null;
              self.buscarTopes(0);
            })
            .catch(() => {
              self.showAlert({
                icon: "error",
                title: "No se pudieron actualizar los precios",
                vm: self,
              });
            })
            .finally(() => {
              self.actualizandoMasivo = false;
            });
        }
      });
    },
  },
  created() {
    const profData = {
      usuario: this.$store.state.usuario.usuario,
      idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
    };
    let self = this;
    axios
      .get("/Turnos/BuscarProfesionalesAsociados?", {
        params: {
          usuario: profData.usuario,
          idInstitucion: profData.idInstitucion,
        },
      })
      .then((response) => {
        self.profsBuscar = response.data.profesionales;
        if (self.profsBuscar.length > 1)
          self.profsBuscar.unshift({
            idProfesional: 0,
            nombreProfesional: "TODOS",
          });

        self.prof = self.profsBuscar[0].idProfesional;
      })
      .catch((error) => {});

    const osData = {
      nombre: null,
      idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
    };

    axios
      .get("/ObraSocial/GetObraSocialNomDeInst?", {
        params: {
          nombre: osData.nombre,
          idInstitucion: osData.idInstitucion,
          estado: 1,
        },
      })
      .then((response) => {
        self.osBuscar = response.data;
        if (self.osBuscar.length > 1)
          self.osBuscar.unshift({ idObraSocial: 0, nombre: "TODAS" });

        self.os = self.osBuscar[0].idObraSocial;
      })
      .catch((error) => {});

    this.buscarTopes(0);
  },
  components: {
    NuevoTope,
    EditarTope,
  },
};
</script>
